// src/pages/FoodItemsPage.jsx

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { collection, getDocs, doc, deleteDoc } from 'firebase/firestore';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import './FoodItemsPage.css';

function FoodItemsPage() {
  const navigate = useNavigate();
  const [foodItems, setFoodItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchItems = async () => {
      try {
        setLoading(true);
        const querySnapshot = await getDocs(collection(db, 'fooditems'));
        const itemsList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setFoodItems(itemsList);
      } catch (err) {
        console.error("Error fetching food items: ", err);
        setError("Failed to load data. Please check your Firestore rules or internet connection.");
      } finally {
        setLoading(false);
      }
    };
    
    fetchItems();
  }, []);

  const handleDelete = async (id, name) => {
    if (window.confirm(`Are you sure you want to delete "${name}"?`)) {
      try {
        await deleteDoc(doc(db, 'fooditems', id));
        setFoodItems(prev => prev.filter(item => item.id !== id));
      } catch (err) {
        console.error("Error deleting item: ", err);
        alert("Failed to delete item.");
      }
    }
  };

  if (loading) return <div className="status-message">Loading...</div>;
  if (error) return <div className="status-message error">{error}</div>;

  return (
    <div className="page-container">
      <div className="page-header">
        <h2>Food Items</h2>
        <button className="add-button" onClick={() => navigate('/food-items/add')}>
          <FaPlus style={{ marginRight: '8px' }} />
          Add Food Item
        </button>
      </div>
      
      <div className="table-container">
        <table className="data-table">
          {/* ================================================================ */}
          {/* === UPDATED TABLE HEADERS TO INCLUDE "COINS"                 === */}
          {/* ================================================================ */}
          <thead>
            <tr>
              <th>Image</th>
              <th>Name</th>
              <th>Category</th>
              <th>Coins</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {foodItems.length > 0 ? (
              foodItems.map(item => (
                <tr key={item.id}>
                  <td><img src={item.imageUrl} alt={item.name} className="item-image" /></td>
                  <td>{item.name}</td>
                  <td>{item.categoryName}</td>
                  {/* ================================================================ */}
                  {/* === ADDED THE TD ELEMENT TO DISPLAY THE COIN VALUE           === */}
                  {/* ================================================================ */}
                  <td>{item.coins}</td>
                  <td>
                    <button className="action-button edit" onClick={() => navigate(`/food-items/edit/${item.id}`)}>
                      <FaEdit />
                    </button>
                    <button className="action-button delete" onClick={() => handleDelete(item.id, item.name)}>
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              // Corrected colSpan to match the new number of columns
              <tr>
                <td colSpan="5" className="empty-message">No food items found. Add one to get started!</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default FoodItemsPage;